<script setup lang="ts">
import {Avatar, Drawer} from "../Components/Library";
import User from "@/Models/User";
import UserMenu from "@/Layouts/UserMenu.vue";

const $user = new User();
const model = defineModel();
const emit = defineEmits<{
    showAskAlbieDrawer: [];
}>();

const showAskAlbieDrawer = () => {
    console.log("open");
    model.value = false;
    emit("showAskAlbieDrawer");
};
</script>
<template>
    <Drawer v-model:visible="model" position="right" modal class="flex w-full max-w-64 flex-col lg:max-w-80">
        <template #header>
            <RouterLink :to="{name: 'profile.edit'}" class="w-full" @click="model = false">
                <div class="transition-color flex items-center gap-2 py-1 duration-200">
                    <Avatar :user="$user" class="h-10 w-10 flex-none" shape="circle" />
                    <h6 class="">
                        {{ $user.user.first_name }}
                        <span class="font-bold">{{ $user.user.last_name }}</span>
                    </h6>
                </div>
            </RouterLink>
        </template>
        <UserMenu @show-ask-albie-drawer="showAskAlbieDrawer" @close="model = false" />
    </Drawer>
</template>
<style scoped></style>
